<div class="client-sso gl-forms__container margin-top-double margin-bottom" *ngIf="ssoConfig?.uuid">
  <ng-container *ngIf="!isCampusSso; else deepLinkList">
    <div class="cards__header">
      <div class="cards__heading">{{ 'clients.config.sso.url' | translate }}</div>
    </div>
    <div class="cards__block">
      <a target="_blank" [href]="ssoUrl">{{ ssoUrl }}</a>
    </div>
  </ng-container>

  <ng-template #deepLinkList>
    <div class="client-sso__actions">
      <gl-select
        *ngIf="isCampusSso && ssoConfig.type === 'saml'"
        [label]="'clients.config.coursesAccessMode' | translate"
        [value]="deepLinkListType"
        [options]="listTypes"
        (onChange)="changeDeepLinkType($event.detail.value)"
      >
      </gl-select>
    </div>
    <gl-button
      *ngIf="deepLinkListType !== 'home'"
      color-secondary
      [text]="'actions.download' | translate"
      class="right margin-bottom"
      (onClick)="downloadLinksXlsx()"
      form-actions-after
    ></gl-button>
    <div *ngIf="deepLinkListType !== 'home'" class="client-sso__search">
      <gl-search
        [placeholder]="'actions.search' | translate"
        (onKeyup)="searchWords($event.detail.value)"
        (onClose)="searchWords('')"
      >
      </gl-search>
    </div>

    <ng-container *ngIf="deepLinkListType !== 'home'; else campus">
      <div *ngIf="tempCourses.length" class="client-sso__table--row thead">
        <div class="column-40">{{ 'nouns.course' | translate }}</div>
        <div class="column-60">{{ 'clients.config.links' | translate }}</div>
      </div>
      <div class="client-sso__scroll">
        <div *ngFor="let course of tempCourses" class="client-sso__table--row">
          <ng-container *ngIf="!!course.uuid">
            <div [title]="course.name" class="column-40 client-sso__ellipsis">{{ course.name }}</div>
            <div class="column-60 client-sso__link">
              <span [title]="getFullSsoUrl(course.uuid)" class="client-sso__ellipsis">
                <a target="_blank" href="{{ getFullSsoUrl(course.uuid) }}"> {{ getFullSsoUrl(course.uuid) }}</a>
              </span>
              <span
                [title]="'actions.copy' | translate"
                class="glicon-copy"
                (click)="copyToClipboard(getFullSsoUrl(course.uuid))"
              ></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="tempItineraries.length" class="client-sso__table--row thead">
        <div class="column-40">{{ 'nouns.itinerary' | translate }}</div>
        <div class="column-60">{{ 'clients.config.links' | translate }}</div>
      </div>
      <div class="client-sso__scroll">
        <div *ngFor="let itinerary of tempItineraries" class="client-sso__table--row">
          <ng-container *ngIf="!!itinerary.uuid">
            <div [title]="itinerary.name" class="column-40 client-sso__ellipsis">{{ itinerary.name }}</div>
            <div class="column-60 client-sso__link">
              <span [title]="getFullSsoUrl(itinerary.uuid)" class="client-sso__ellipsis">
                <a target="_blank" href="{{ getFullSsoUrl(itinerary.uuid) }}"> {{ getFullSsoUrl(itinerary.uuid) }}</a>
              </span>
              <span
                [title]="'actions.copy' | translate"
                class="glicon-copy"
                (click)="copyToClipboard(getFullSsoUrl(itinerary.uuid))"
              ></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="!tempCourses.length && !tempItineraries.length" class="client-sso__placeholder">
        <div class="glicon-nodata"></div>
        <div class="text">{{ 'actions.noResultTable' | translate }}</div>
      </div>
    </ng-container>
    <ng-template #campus>
      <div class="cards__block" #campus>
        <a target="_blank" [href]="ssoUrl">{{ ssoUrl }}</a>
      </div>
    </ng-template>
  </ng-template>
</div>

<lms-dynamic-form
  #ssoConfigForm
  [questions]="questions"
  [action]="'clients.sso'"
  [options]="{ showSpinnerUponSubmitting: false, disableCard: true }"
  (submit)="submit($event)"
></lms-dynamic-form>
